// extracted by mini-css-extract-plugin
module.exports = {"personalTaxIncome":"style_personalTaxIncome__20CEe","paragraphs":"style_paragraphs__opid1","standAlone":"style_standAlone__D44sE"};